
































































import Vue from 'vue'
import { Component, Prop, Emit, Watch } from 'vue-property-decorator'

@Component
export default class FilterTextSearch<T> extends Vue {
  @Prop({ type: String }) readonly value!: string
  @Prop({ type: String }) readonly placeholder!: string
  @Prop({ type: [Number, String], default: '289' }) readonly width!: number | string
  @Prop({ type: Array }) readonly items!: string[]
  @Prop({ type: Boolean, default: false }) readonly showSearchBtn!: boolean
  @Prop({ type: Boolean, default: false }) readonly returnObject!: boolean
  @Prop({ type: String, default: '' }) readonly className!: string
  @Prop({ type: String, default: '' }) readonly label!: string
  @Prop({ type: Boolean, default: false }) readonly dense!: boolean

  model = ''

  delay: any = null

  listPosConf = {
    top: 0,
    left: 0
  }

  showList = false
  stopBlurHandler = false

  selectedIdx = -1

  get options () {
    return this.items
  }

  mounted () {
    if (this.value) {
      this.model = this.value
    }
  }

  onResize () {
    const inputDom = this.$refs.searchOrInput as Vue & {
      getBoundingClientRect: () => any;
    }

    const input = inputDom.getBoundingClientRect()
    this.listPosConf.top = input.y + 36
    this.listPosConf.left = input.x
  }

  remove (item: string) {
    if (!Array.isArray(this.model)) {
      return
    }
    const index = this.value.indexOf(item)
    if (index >= 0) this.model.splice(index, 1)
  }

  @Watch('items', {
    deep: true
  })
  onItemsChanged () {
  }

  @Watch('value')
  onValueChanged (val: string) {
    this.model = val
  }

  @Watch('model')
  onSearchChanged (val: string) {
    const test = (Array.isArray(this.model) && this.$R.contains(val, this.model))
    if (test) return
    this.valueChangedHandler()
    clearTimeout(this.delay)
    this.delay = setTimeout(() => {
      this.searchHandler()
    }, 500)
  }

  focusHandler () {
    this.onResize()
    this.stopBlurHandler = false
    this.showList = true
  }

  blurHandler () {
    setTimeout(() => {
      this.showList = false
    }, 500)
  }

  keyDownHandler (e: KeyboardEvent) {
    const selectedIdx = !isNaN(this.selectedIdx)
      ? this.selectedIdx
      : -1
    switch (e.key) {
      case 'ArrowUp' :
        this.selectedIdx = selectedIdx - 1 < 0 ? 0 : selectedIdx - 1
        break
      case 'ArrowDown' :
        this.selectedIdx = selectedIdx + 1 > this.items.length - 1 ? this.items.length - 1 : selectedIdx + 1
        break
      case 'Enter' :
        this.selectHandler(selectedIdx)
        break
      case 'Backspace' :
        this.showList = true
    }
  }

  @Emit('query')
  searchHandler () {
    if (this.returnObject) {
      let val = {
        name: this.model,
        type: 'query'
      }
      return val
    } else {
      return this.model
    }
  }

  @Emit('input')
  valueChangedHandler () {
    return this.model
  }

  @Emit('selected')
  selectHandler (idx: number) {
    const selected = this.items[idx]
    if (selected) {
      this.model = selected
    }
    this.showList = false
    return selected
  }

  clearModel () {
    this.stopBlurHandler = true
    this.model = ''
    this.valueChangedHandler()
  }
}
